module.exports = __webpack_public_path__ + "static/media/hamburguerMenu.d1e01fe1.svg";